import intlTelInput from 'intl-tel-input';
import utils from 'intl-tel-input/build/js/utils';

document.addEventListener('alpine:init', () => {
    Alpine.data('applyForm', () => ({
        showTooltip: false,
        fileName: null,
        iti: null,
        isValidNumber: null,
        setFileName(event) {
            this.fileName = event.target.files[0].name;
        },
        clearFile() {
            this.fileName = null;
            this.$refs.resume.value = '';
        },
        validatePhoneNumber() {
            this.isValidNumber = this.iti.isValidNumber();
        },
        init() {
            const input = this.$refs.phoneInput;
            this.iti = intlTelInput(input, {
                utilsScript: utils,
                initialCountry: 'BE',
            });
            
            const itiInstance = this.iti;
            const phoneNumberCountryCodeInput =  this.$refs.phoneNumberCountryCode;
            
            if (phoneNumberCountryCodeInput.value !== '') {
                itiInstance.setCountry(phoneNumberCountryCodeInput.value);
            }

            document.addEventListener("countrychange", function() {
                const selectedCountryData = itiInstance.getSelectedCountryData()
                phoneNumberCountryCodeInput.value = selectedCountryData.iso2;
            });
        },
    }))
})

